import { createSelector } from "reselect";

export const getSingleSitesListSites = (state) => state.sites.all.singleSites.sites;
export const getSingleSitesListTimeframe = (state) => state.sites.all.singleSites.timeframe;

export const getSingleSitesList = createSelector(
  [getSingleSitesListSites, getSingleSitesListTimeframe],
  (sites, timeframe) => {
    return sites.map((site) => {
      return {
        ...site,
        timeframe: timeframe,
      }
    })
  }
);